export const LAZY_LOADED_EVENT = 'lozad.images.loaded';
